import { createSlice } from "@reduxjs/toolkit";

import { del, get, patch, post } from "../../helpers/axios";
import { ADMIN_LIBRARY_LIST, LIBRARY_LIST } from "../../helpers/url_helpers";

const initialState = {
  loading: false,
  libraryListingError: [],
  newLibraryError: [],
  libraryList: [],
};
const controlLibrary = createSlice({
  name: "controlLibrary",
  initialState,
  reducers: {
    setLibraryList: (state, action) => {
      state.libraryList = action.payload.libraryList;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLibraryListingError: (state, action) => {
      state.libraryListingError = action.payload.libraryListingError;
    },
    setNewLibraryError: (state, action) => {
      state.newLibraryError = action.payload.newLibraryError;
    },
  },
});

export const {
  setLoading,
  setLibraryListingError,
  setLibraryList,
  setNewLibraryError,
} = controlLibrary.actions;
export default controlLibrary.reducer;

export const getLibraries = (orgId) => async (dispatch) => {
  let response;
  try {
    dispatch(setLibraryListingError({ libraryListingError: "" }));
    dispatch(setNewLibraryError({ newLibraryError: "" }));
    dispatch(setLoading(true));
    // api call
    response = orgId
      ? await get(ADMIN_LIBRARY_LIST + orgId)
      : await get(LIBRARY_LIST);

    if (response) {
      if (response.error) {
        dispatch(
          setLibraryListingError({
            libraryListingError: response?.error,
          })
        );
      } else {
        dispatch(
          setLibraryList({
            libraryList: response?.data,
          })
        );
      }
    }
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(
      setLibraryListingError({
        libraryListingError: error,
      })
    );
    dispatch(setLoading(false));
  }
};

export const addLibrary = (payload, callback) => async (dispatch) => {
  let response;
  try {
    dispatch(setLoading(false));
    dispatch(setNewLibraryError({ newLibraryError: "" }));
    dispatch(setLibraryListingError({ libraryListingError: "" }));

    // api call
    response = await post(LIBRARY_LIST, payload);

    if (response) {
      dispatch(setLoading(false));
      if (response.error) {
        dispatch(
          setNewLibraryError({
            newLibraryError: response?.error,
          })
        );
        if (callback) callback("failure");
      } else {
        if (callback) callback("success");
      }
    }
  } catch (error) {
    dispatch(setLoading(false));

    dispatch(
      setNewLibraryError({
        newLibraryError: error,
      })
    );
  }
};

export const editLibrary = (payload, linkId, callback) => async (dispatch) => {
  let response;
  try {
    dispatch(setLoading(true));
    dispatch(setNewLibraryError({ newLibraryError: "" }));
    dispatch(setLibraryListingError({ libraryListingError: "" }));

    // api call
    response = await patch(LIBRARY_LIST + linkId + "/", payload);

    if (response) {
      dispatch(setLoading(false));
      if (response.error) {
        dispatch(
          setNewLibraryError({
            newLibraryError: response?.error,
          })
        );
        if (callback) callback("failure");
      } else {
        if (callback) callback("success");
      }
    }
  } catch (error) {
    dispatch(setLoading(false));

    dispatch(
      setLibraryListingError({
        libraryListingError: error,
      })
    );
  }
};

export const deleteLibrary = (linkId, callback) => async (dispatch) => {
  let response;
  try {
    dispatch(setLoading(true));
    dispatch(setLibraryListingError({ libraryListingError: "" }));
    dispatch(setNewLibraryError({ newLibraryError: "" }));

    // api call
    response = await del(LIBRARY_LIST + linkId + "/");

    if (response) {
      dispatch(setLoading(false));
      if (response.error) {
        dispatch(
          setLibraryListingError({
            libraryListingError: response?.error,
          })
        );
        if (callback) callback("failure");
      } else {
        if (callback) callback("success");
      }
    }
  } catch (error) {
    dispatch(setLoading(false));

    dispatch(
      setLibraryListingError({
        libraryListingError: response?.error,
      })
    );
  }
};
